export function initRealisations() {
	document.querySelectorAll("[data-realisations]").forEach((section) => {
		if (section.dataset.initialized === "true") return;
		section.dataset.initialized = "true";

		const grid = section.querySelector(".c-realisations_grid");
		if (!grid) return;

		const items = [...grid.querySelectorAll(".c-realisations_item")];
		const buttons = [...section.querySelectorAll("[data-filter]")];
		const status = section.querySelector(".c-realisations_status");
		const galleryId = section.dataset.gallery;

		const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

		let activeAnimations = [];
		let revision = 0;

		const animate = (element, frames, options) => {
			const animation = element.animate(frames, options);
			activeAnimations.push(animation);
			return animation;
		};

		const waitFor = (animations) => Promise.allSettled(animations.map((animation) => animation.finished));

		const filterItems = async (filter) => {
			const currentRevision = ++revision;

			activeAnimations.forEach((animation) => animation.cancel());
			activeAnimations = [];

			const previousItems = items.filter((item) => !item.hidden);

			const nextItems = items.filter((item) => {
				const categories = (item.dataset.categories || "").split(/\s+/).filter(Boolean);

				return filter === "all" || categories.includes(filter);
			});

			const nextSet = new Set(nextItems);
			const previousSet = new Set(previousItems);
			const leavingItems = previousItems.filter((item) => !nextSet.has(item));

			buttons.forEach((button) => {
				const active = button.dataset.filter === filter;

				button.classList.toggle("is-active", active);
				button.setAttribute("aria-pressed", String(active));
			});

			const shouldAnimate = !reducedMotion.matches && typeof grid.animate === "function";

			// Disparition des images exclues avant le déplacement.
			if (shouldAnimate) {
				await waitFor(
					leavingItems.map((item) =>
						animate(item, [{ opacity: 1 }, { opacity: 0 }], {
							duration: 100,
							easing: "ease-out",
							fill: "forwards",
						}),
					),
				);
			}

			if (currentRevision !== revision) return;

			const oldPositions = new Map(previousItems.map((item) => [item, item.getBoundingClientRect()]));

			const oldHeight = grid.getBoundingClientRect().height;

			items.forEach((item) => {
				const visible = nextSet.has(item);

				item.hidden = !visible;
				item.classList.remove("is-large");

				// Les images cachées sortent aussi de l'album Lightbox.
				if (visible) {
					item.setAttribute("data-lightbox", galleryId);
				} else {
					item.removeAttribute("data-lightbox");
				}
			});

			// Mosaïque sur les groupes complets de 14.
			// Les images restantes gardent une taille standard.
			const mosaicCount = Math.floor(nextItems.length / 14) * 14;

			nextItems.forEach((item, index) => {
				const large = index < mosaicCount && [0, 7].includes(index % 14);

				item.classList.toggle("is-large", large);
			});

			const newHeight = grid.getBoundingClientRect().height;

			const newPositions = new Map(nextItems.map((item) => [item, item.getBoundingClientRect()]));

			activeAnimations.forEach((animation) => animation.cancel());
			activeAnimations = [];

			status.textContent = `${nextItems.length} réalisation${nextItems.length > 1 ? "s" : ""}`;

			if (!shouldAnimate) return;

			const options = {
				duration: 250,
				easing: "cubic-bezier(0.22, 1, 0.36, 1)",
			};

			nextItems.forEach((item) => {
				const before = oldPositions.get(item);
				const after = newPositions.get(item);

				if (previousSet.has(item) && before && after) {
					const deltaX = before.left - after.left;
					const deltaY = before.top - after.top;
					const scaleX = before.width / after.width;
					const scaleY = before.height / after.height;

					animate(
						item,
						[
							{
								transformOrigin: "top left",
								transform: `translate(${deltaX}px, ${deltaY}px) ` + `scale(${scaleX}, ${scaleY})`,
							},
							{
								transformOrigin: "top left",
								transform: "translate(0, 0) scale(1, 1)",
							},
						],
						options,
					);
				} else {
					animate(item, [{ opacity: 0 }, { opacity: 1 }], options);
				}
			});

			// Accompagne aussi le déplacement du contenu sous la grille.
			if (oldHeight !== newHeight) {
				animate(grid, [{ height: `${oldHeight}px` }, { height: `${newHeight}px` }], options);
			}
		};

		buttons.forEach((button) => {
			button.addEventListener("click", () => {
				if (button.classList.contains("is-active")) return;
				filterItems(button.dataset.filter);
			});
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initRealisations);
} else {
	initRealisations();
}
